import { Flex } from '@mantine/core';
import { SummaryTile } from 'components/Onboarding/SummaryTile';
import { IconCalendar, IconDroplet, IconPower, IconWallet, IconWifi } from '@tabler/icons-react';
import { SummaryPill } from 'components/Onboarding/SummaryPill';
import { ChevronRight } from 'tabler-icons-react';
import { routes } from 'routes/router';
import { OnboardingLayout } from 'layouts/Onboarding';

const { Root, Header, HeaderTitle, Body, Footer, FooterButton } = OnboardingLayout;

export function TenantOnboardingReviewLeaseSummary() {
    return (
        <Root headerProps={{ backButton: true, children: 'Review Lease Summary' }}>
            <Header>
                <HeaderTitle>Lease details</HeaderTitle>
            </Header>
            <Body>
                <Flex gap="md">
                    <SummaryTile icon={<IconCalendar />} title="12 months" subtitle="Rental Term" />
                    <SummaryTile icon={<IconWallet />} title="$4,000" subtitle="Monthly Rent" />
                </Flex>
            </Body>
            <Body>
                <HeaderTitle>Lease summary</HeaderTitle>
                <SummaryPill title="Lease term">12 months</SummaryPill>
                <SummaryPill title="Utilities" subtitle="Water, gas, electricity, and internet not provided.">
                    Tenant pays
                </SummaryPill>
                <SummaryPill title="Rent adjustments" subtitle="Increases at landlords discretion.">
                    Up to 10% per year
                </SummaryPill>
                <SummaryPill title="Entry" subtitle="Landlord has the right to enter the property with 3 day notice.">
                    3 day notice
                </SummaryPill>
            </Body>
            <Body>
                <HeaderTitle>Utilities and service</HeaderTitle>
                <Flex gap="md">
                    <SummaryTile icon={<IconDroplet />} title="$50" subtitle="Water" />
                    <SummaryTile icon={<IconPower />} title="$100" subtitle="Electricity" />
                    <SummaryTile icon={<IconWifi />} title="$50" subtitle="Internet" />
                </Flex>
            </Body>
            <Body>
                <HeaderTitle>Lease agreement</HeaderTitle>
                <SummaryPill
                    title="The unit is furnished. The landlord agrees to provide the following furniture and appliances:"
                    subtitle="Sofa, dining table, double bed, TV, washer, dryer, refrigerator, microwave."
                />
                <SummaryPill
                    title="Tenant's right to terminate"
                    subtitle="In the event of a sale of the property, tenant may terminate this lease by providing landlord at least 30 days prior written notice."
                />
                {/* <SummaryPill title="Request changes" iconLeft={<ChevronRight />} /> */}
            </Body>

            <Footer>
                <FooterButton dest={routes.tenantOnboarding.payment}>Agree and continue</FooterButton>
            </Footer>
        </Root>
    );
}
